export const REPARATUR = '189F2F6B82D';
export const SERIENFREIGABE = '189F2F6C6FF';
export const SONSTIGES = '189F2F6E66F';
